import React from 'react';
import { GcalStatus, IGcalContext, ISignInInfo } from './gcal';

export const GcalContext = React.createContext<IGcalContext>({
  client: null,
  status: GcalStatus.STARTUP,
  user: null,
  signIn: async (_: ISignInInfo) => undefined,
  signOut: (_?: string) => undefined,
  getSession: () => Promise.reject(),
});
GcalContext.displayName = 'Gcal Context';

export const GcalConsumer = GcalContext.Consumer;
